import Fade from '@mui/material/Fade';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {useState} from 'react';
import {colorPalette} from '@jobseeker/lotus/foundations/colors';
import Box from '@mui/material/Box';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {ChevronRight} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {shallowEqual, useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';
import {TrackEventUBA} from '@jobseeker/common-core/utils';

import type {MenuItemType, Props} from '../types';

const Default = (props: Props) => {
  const {
    indexTab,
    open,
    anchorEl,
    menuItems = [],
    handleMenuClose,
    theme,
    width,
  } = props || {};
  const [arrowRef, setArrowRef] = useState(null);
  const [showNested, setShowNested] = useState(false);
  const [nestedMenu, setNestedMenu] = useState<MenuItemType[]>();
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const handleMouseEnter = (menu: MenuItemType[]) => {
    if (menu?.length > 0) {
      setNestedMenu(menu);
      setShowNested(true);
    }
  };

  const handleMouseLeave = () => {
    setShowNested(false);
  };

  const catId = useSelector(
    (state: AppState) => state.app.context.navigation.actualCategory
  );

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const trackEvent = (clickedMenuName: string, tagId?: string) => {
    TrackEventUBA('topMenuClick', 'click', {
      categoryID: page === 'category' ? catId : undefined,
      tagID: page === 'tag' ? Number(tagId) : undefined,
      page,
      sessionUsername: sessionStorage.getItem('userId') || '',
      clickedMenuName,
    });
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      id="menu-list-grow"
      placement="bottom-start"
      onMouseLeave={handleMenuClose}
      modifiers={[
        {
          name: 'arrow',
          enabled: true,
          options: {
            element: arrowRef,
          },
        },
      ]}
      sx={{
        paddingTop: isAppIimjobs ? '10px' : '8px',
        zIndex: 1200,
      }}
      transition
    >
      {({TransitionProps}) => (
        <Fade {...TransitionProps} timeout={500}>
          {/* <StyledArrowSpan ref={setArrowRef} /> */}
          <Paper
            sx={{
              width: isAppIimjobs ? '280px' : width ? width : '340px',
              backgroundColor: colorPalette.white.A50,
              boxShadow: '0px 6.480000019073486px 6px rgba(41, 41, 41, 0.06)',
              borderRadius: theme.spacing(isAppIimjobs ? 2 : 1),
              minWidth: isAppIimjobs ? '280px' : '200px',
              // border: '1px rgba(126, 126, 126, 0.20) solid',
            }}
            onMouseLeave={handleMouseLeave}
          >
            <MenuList key={`lotus-menulist-single`}>
              {menuItems.map((item, index) => {
                const {
                  tag,
                  label,
                  link,
                  menu,
                  dataId: tagId,
                  handleClick,
                } = item || {};
                return (
                  label && (
                    <>
                      <MenuItem
                        key={`lotus-menu-menulink-${index}`}
                        onClick={event => {
                          event?.preventDefault();
                          const url = tag
                            ? `/${menu && menu?.length > 0 ? 'c' : 'k'}/${tag
                                .replace('&', '')
                                .replace(/\s+/g, '-')
                                .toLowerCase()}-jobs${
                                !isAppIimjobs ? '?ref=topnavigation' : ''
                              }`
                            : link
                            ? link
                            : '#';
                          setTimeout(() => {
                            handleMenuClose();
                            if (handleClick) {
                              handleClick();
                              return;
                            }
                            trackEvent(label, tagId);
                            if (url && url !== '#') {
                              openUrl(url, '_self');
                            }
                          }, 0);
                        }}
                        onMouseEnter={() => menu && handleMouseEnter(menu)}
                        sx={
                          isAppIimjobs
                            ? {
                                fontSize: 14,
                                // ':hover': {color: theme.palette.primary.main},
                                ':hover': {
                                  backgroundColor: colorPalette.green.A601,
                                  color: theme.palette.secondary.main,
                                },
                                wordBreak: 'break-word',
                                whiteSpace: 'normal',
                                justifyContent: 'space-between',
                              }
                            : {
                                display: 'flex',
                                justifyContent: 'space-between',
                                textWrap: 'nowrap',
                                width: 'auto',
                                margin: 0,
                                fontSize: 16,
                                fontWeight: 500,
                                lineHeight: 2.2,
                                color: '#000',
                                ':hover': {
                                  backgroundColor: colorPalette.black.A50,
                                  color: theme.palette.secondary.main,
                                },
                                padding: '5px 0 5px 15px',
                                cursor: 'pointer',
                              }
                        }
                      >
                        <a
                          href={
                            tag
                              ? `/${menu && menu?.length > 0 ? 'c' : 'k'}/${tag
                                  .replace('&', '')
                                  .replace(/\s+/g, '-')
                                  .toLowerCase()}-jobs${
                                  !isAppIimjobs ? '?ref=topnavigation' : ''
                                }`
                              : link
                              ? link
                              : '#'
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            const url =
                              tag
                                ? `/${menu && menu?.length > 0 ? 'c' : 'k'}/${tag
                                    .replace('&', '')
                                    .replace(/\s+/g, '-')
                                    .toLowerCase()}-jobs${
                                    !isAppIimjobs ? '?ref=topnavigation' : ''
                                  }`
                                : link
                                ? link
                                : '#';
                            if (url !== '#') {
                              setTimeout(() => openUrl(url, '_self'), 0);
                            }
                          }}
                          target="_self"
                          style={{
                            textDecoration: 'none',
                            color: 'inherit',
                          }}
                        >
                          {label?.toLowerCase().includes('jobs') ||
                          label?.toLowerCase().includes('courses') ||
                          label?.toLowerCase().includes('advertise with us') ||
                          label?.toLowerCase().includes('frequently asked questions') ||
                          label?.toLowerCase().includes('all things talent') ||
                          label?.toLowerCase().includes('sitemap') ||
                          label?.toLowerCase().includes('contact us') ||
                          label?.toLowerCase().includes('login')
                            ? label
                            : `${label} Jobs`}
                        </a>
                        {menu && menu?.length > 0 && (
                          <Image
                            src={ChevronRight}
                            alt={'right'}
                            width={14}
                            height={14}
                            style={{
                              verticalAlign: 'middle',
                              margin: isAppIimjobs ? '0 0px' : '0 15px',
                            }}
                          />
                        )}
                      </MenuItem>
                      {label === 'GenAI' && (
                        <Box
                          sx={{
                            display: 'flex',
                            width: '85%',
                            height: '1px',
                            backgroundColor: '#EEEEEE',
                            my: 1,
                            margin: '0 auto',
                          }}
                        />
                      )}
                    </>
                  )
                );
              })}
              {}
            </MenuList>

            {/* Nested menu rendering */}
            {showNested && nestedMenu && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 10,
                  left: '100%',
                  ...(isAppIimjobs && {width: '290px'}),
                  mt: isAppIimjobs ? 0 : 0.8,
                  px: isAppIimjobs ? 0 : 1.5,
                  backgroundColor: isAppIimjobs
                    ? colorPalette.white.A50
                    : colorPalette.black.A50,
                  boxShadow: isAppIimjobs
                    ? '0px 6.480000019073486px 6px rgba(41, 41, 41, 0.06)'
                    : '',
                  borderBottomRightRadius: theme.spacing(isAppIimjobs ? 2 : 1),
                  borderTopRightRadius: theme.spacing(isAppIimjobs ? 2 : 1),
                  borderBottomLeftRadius: isAppIimjobs ? theme.spacing(2) : 0,
                  borderTopLeftRadius: isAppIimjobs ? theme.spacing(2) : 0,
                  zIndex: 1201,
                }}
              >
                <MenuList key={`lotus-menulist-nested`}>
                  {nestedMenu.map((nestedItem, nestedIndex) => {
                    const {label, link, tag} = nestedItem || {};
                    return (
                      label && (
                        <MenuItem
                          key={`lotus-menu-nested-${nestedIndex}`}
                          onClick={event => {
                            event?.preventDefault();
                            const url = tag
                              ? `/k/${tag
                                  .replace('&', '')
                                  .replace(/\s+/g, '-')
                                  .toLowerCase()}-jobs${
                                  !isAppIimjobs ? '?ref=topnavigation' : ''
                                }`
                              : link
                              ? link
                              : '#';
                            setTimeout(() => {
                              handleMenuClose();
                              if (url && url !== '#') {
                                openUrl(url, '_self');
                              }
                            }, 0);
                          }}
                          sx={{
                            fontSize: isAppIimjobs ? 14 : 16,
                            fontWeight: isAppIimjobs ? 400 : 500,
                            px: 2,
                            alignItems: 'center',
                            ':hover': {
                              backgroundColor: isAppIimjobs
                                ? colorPalette.green.A601
                                : colorPalette.white.A50,
                              borderRadius: 1,
                              color: theme.palette.secondary.main,
                            },
                            ...(!isAppIimjobs
                              ? {
                                  minHeight: '45px !important',
                                  height: '45px !important',
                                }
                              : {}),
                          }}
                        >
                          <a
                            href={
                              tag
                                ? `/k/${tag
                                    .replace('&', '')
                                    .replace(/\s+/g, '-')
                                    .toLowerCase()}-jobs${
                                    !isAppIimjobs ? '?ref=topnavigation' : ''
                                  }`
                                : link
                                ? link
                                : '#'
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              const url =
                                tag
                                  ? `/k/${tag
                                      .replace('&', '')
                                      .replace(/\s+/g, '-')
                                      .toLowerCase()}-jobs${
                                      !isAppIimjobs ? '?ref=topnavigation' : ''
                                    }`
                                  : link
                                  ? link
                                  : '#';
                              if (url !== '#') {
                                setTimeout(() => openUrl(url, '_self'), 0);
                              }
                            }}
                            target="_self"
                            style={{
                              textDecoration: 'none',
                              color: 'inherit',
                            }}
                          >
                            {isAppIimjobs ? `${label} Jobs` : label}
                          </a>
                        </MenuItem>
                      )
                    );
                  })}
                </MenuList>
              </Box>
            )}
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default Default;
